import type { CartItem as CartItemType } from "../types";
import { useCart } from "../context/CartContext";

interface CartItemProps {
  item: CartItemType;
}

export function CartItem({ item }: CartItemProps) {
  const { updateQuantity, removeFromCart } = useCart();

  return (
    <div className="flex gap-4 p-4 border-b border-gray-200">
      <div className="w-24 h-24 bg-gray-100 rounded flex-shrink-0 overflow-hidden">
        {item.product.primaryImage ? (
          <img
            src={item.product.primaryImage}
            alt={item.product.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-400 text-xs">
            No Image
          </div>
        )}
      </div>
      <div className="flex-1">
        <h3 className="font-semibold mb-1">{item.product.name}</h3>
        <p className="text-gray-600 text-sm mb-2">
          ${item.product.price.toFixed(2)} each
        </p>
        <div className="flex items-center gap-2">
          <button
            onClick={() => updateQuantity(item.product.id, item.quantity - 1)}
            className="w-8 h-8 border border-gray-300 rounded hover:bg-gray-100"
            aria-label="Decrease quantity"
          >
            −
          </button>
          <span className="w-12 text-center">{item.quantity}</span>
          <button
            onClick={() => updateQuantity(item.product.id, item.quantity + 1)}
            className="w-8 h-8 border border-gray-300 rounded hover:bg-gray-100"
            aria-label="Increase quantity"
          >
            +
          </button>
        </div>
      </div>
      <div className="text-right">
        <p className="font-bold mb-2">
          ${(item.product.price * item.quantity).toFixed(2)}
        </p>
        <button
          onClick={() => removeFromCart(item.product.id)}
          className="text-red-600 hover:text-red-700 text-sm"
        >
          Remove
        </button>
      </div>
    </div>
  );
}
